const state = {
  token: null,
  loggedin: false,
  loggingIn: false,
  loginError: null,
  loader: false,
  user: null,
  registering: false,
  currentClient: null,
  clients: null,
  language: 'en',
  // cms



}
export default state
